export default "__VITE_ASSET__$WOKKna1__"